import { Field, Form, Formik } from 'formik';
import { Button, Modal } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { IAddEditFormProps } from '../../../../models/forms/IForm';
import { IOption } from '../../../../models/ICommon';
import FormikFormSelect from '../../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormLoader from '../../../../shared-components/FormLoader/FormLoader';
import Label from '../../../../shared-components/label/label';
import { formatMessage } from '../../../../translations/format-message';
import { LEDBlinkValidationSchema } from '../../../../shared-components/FormikFormHandlers/FormikValidationSchema';

interface IProps extends IAddEditFormProps<any> {
  duplicateData: string;
  timerOptions: IOption[];
  colorOptions: IOption[];
}

const LEDBlinkForm = (props: IProps) => {
  return (
    <Formik
      initialValues={props.initialValues}
      enableReinitialize
      validateOnBlur={false}
      validationSchema={LEDBlinkValidationSchema}
      onSubmit={(values) => {
        props.submitHandler(values);
        props.onModalClosed();
      }}
    >
      {() => (
        <Form className="user-form">
          {props.isLoading && (
            <p>
              <FormLoader loading={props.isLoading} />
            </p>
          )}
          <Modal.Body>
            <div className="row">
              <div className="col-6">
                <div className="form-group formSet">
                  <Label
                    className="label-style col-form-label"
                    required={true}
                    label="colorCode"
                  />

                  <Field
                    name="ColorCode"
                    as={FormikFormSelect}
                    options={props.colorOptions}
                    setDefaultValue={true}
                    className="form-control"
                  />
                </div>
              </div>

              <div className="col-6">
                <div className="form-group formSet">
                  <Label
                    className="label-style col-form-label"
                    required={true}
                    label="duration"
                  />
                  <Field
                    name="Second"
                    as={FormikFormSelect}
                    options={props.timerOptions}
                    getData={true}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="light-danger"
              type="button"
              onClick={props.onModalClosed}
            >
              <FormattedMessage id="cancel" />
            </Button>
            <Button
              type="submit"
              className=""
            >
              {formatMessage('blink')}
            </Button>
          </Modal.Footer>
        </Form>
      )}
    </Formik>
  );
};

export default LEDBlinkForm;
